import { FileAddOutlined, FileExcelOutlined, FilterOutlined, SettingOutlined } from '@ant-design/icons'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useModal } from '../../../../../common/hooks/formik/modal.hook'
import { KeyLabel } from '../../../../../common/types/common.type'
import { ModalCenter } from '../../../../../common/ui/modal/modal-center'
import { PureButton } from '../../../../../common/ui/pure-button/pure-button'
import { PureDropdown } from '../../../../../common/ui/pure-dropdown/pure-dropdown'
import { useExportExcel } from '../../../../../entities/excel/hooks/excel.hooks'
import { useWorkspaceStore } from '../../../../../entities/workflow/stores/workspace.store'
import { MilestoneItem } from '../../../../../entities/workflow/types/workflow.types'
import { WorkspaceExcelExport, workspaceExcelExportOptions, WorkspaceWorkMode } from '../../constants/workspace.constants'
import { WorkspaceConfiguration } from '../../types/wrokspace.types'
import { WorkspaceFilter } from '../workspace-fllter/workspace-filter'
import { WorkspaceSettings } from '../workspace-settings/workspace-settings'

type WorkspaceControlsProps = {
  milestones: MilestoneItem[]
}

export const WorkspaceControls = ({ milestones }: WorkspaceControlsProps) => {
  const { t } = useTranslation()
  const [isFilterOpened, openFilter, closeFilter] = useModal()
  const [isSettingsOpened, openSettings, closeSettings] = useModal()
  const [excelExportOptions, setExcelExportOptions] = useState<KeyLabel<WorkspaceExcelExport>[]>([])
  const { mutateAsync: exportExcel } = useExportExcel()
  const { setConfiguration, workspaceConfiguration, checkedMilestones, checkedObjects } = useWorkspaceStore()

  useEffect(() => {
    const translatedExportOptions = workspaceExcelExportOptions.map((option) => ({
      ...option,
      label: t(option.label),
    }))
    setExcelExportOptions(translatedExportOptions)
  }, [])

  const handleFilterClick = () => {
    closeSettings()
    openFilter()
  }

  const handleSettingsClick = () => {
    closeFilter()
    openSettings()
  }

  const handleTemplateClick = () => {
    console.log(checkedMilestones)
  }

  const handleExcelExportClick = (exportItemKey: string) => {
    closeFilter()
    closeSettings()
    exportExcel({
      type: exportItemKey as WorkspaceExcelExport,
      checkedMilestones: Array.from(checkedMilestones),
      checkedObjects: Array.from(checkedObjects),
    })
  }

  const handleChangeWorkspaceSettings = (settings: Partial<WorkspaceConfiguration>) => {
    setConfiguration(settings)
  }

  return (
    <>
      <div className="d-flex justify-content-between">
        <div>
          <PureDropdown
            button={
              <PureButton size="small">
                <FileExcelOutlined />
                {t('common.exportExcel')}
              </PureButton>
            }
            items={excelExportOptions}
            onSelected={handleExcelExportClick}
          />
          <PureButton
            className="ml-1 ps-3 pe-3"
            onClick={handleTemplateClick}
            size="small"
          >
            <FileAddOutlined />
          </PureButton>
        </div>
        <div className="d-flex align-items-center">
          <div>Режим: {workspaceConfiguration.workMode === WorkspaceWorkMode.Checking ? <b>Проверка</b> : <b>Заполнение</b>}</div>
          <PureButton
            className="ml-1 ps-3 pe-3"
            onClick={handleFilterClick}
            size="small"
          >
            <FilterOutlined />
          </PureButton>
          <PureButton
            className="ml-1 ps-3 pe-3"
            onClick={handleSettingsClick}
            size="small"
          >
            <SettingOutlined />
          </PureButton>
        </div>
      </div>
      <ModalCenter
        footer={null}
        onCancel={closeFilter}
        open={isFilterOpened}
        width="100vw"
      >
        <WorkspaceFilter milestones={milestones} />
      </ModalCenter>
      <ModalCenter
        footer={null}
        onCancel={closeSettings}
        open={isSettingsOpened}
      >
        <WorkspaceSettings
          init={workspaceConfiguration}
          onChange={handleChangeWorkspaceSettings}
        />
      </ModalCenter>
    </>
  )
}
